import React, { useEffect, useState } from "react";
import { useWhatsAppNumber } from "./provider";
import { useNavigate, useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import FormWhatsAppNumber from "./FormWhatsAppNumber";
import ModalBox from "../../ui/ModalBox";

const UpdateWhatsAppNumber = () => {
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    state: { selected: whatsAppNumberInfo },
    fetchOne,
  } = useWhatsAppNumber();

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  useEffect(() => {
    fetchOne(id);
  }, [id]);
  const handleSuccess = () => {
    setOpen(true);
  };
  if (!whatsAppNumberInfo) return;
  if (whatsAppNumberInfo?.id != id) return;
  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Update WhatsApp Number
      </Typography>
      <FormWhatsAppNumber
        handleSuccess={handleSuccess}
        whatsAppNumber={whatsAppNumberInfo}
      />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The update operation has been completed successfully.."
        name="Whats App Number"
      />
    </>
  );
};

export default UpdateWhatsAppNumber;
